export interface StringDevViewportPolicy {
  coarsePointer: boolean;
  compact: boolean;
}

const COMPACT_VIEWPORT_WIDTH = 1024;

function canUseMatchMedia(): boolean {
  return typeof window !== "undefined" && typeof window.matchMedia === "function";
}

export function isCoarsePointerDevice(): boolean {
  if (!canUseMatchMedia()) {
    return false;
  }

  return (
    window.matchMedia("(pointer: coarse)").matches ||
    window.matchMedia("(any-pointer: coarse)").matches
  );
}

export function getStringDevViewportPolicy(
  viewportWidth: number = typeof window !== "undefined" ? window.innerWidth : COMPACT_VIEWPORT_WIDTH,
): StringDevViewportPolicy {
  const coarsePointer = isCoarsePointerDevice();
  const compact = viewportWidth <= COMPACT_VIEWPORT_WIDTH || coarsePointer;

  return {
    coarsePointer,
    compact,
  };
}
